import Grid from '@material-ui/core/Grid'
import Color from 'color'
import DatePicker from 'Components/DatePicker'
import Checkbox from 'Components/Switch'
import Data from 'EurestoClass/Data'
import DataComponent from 'EurestoComponents/DataComponents'
import InputClient from 'EurestoComponents/InputClient'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import moment from 'moment'
import React from 'react'


moment.locale('fr')

class SearchResa extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      search: props.search,
      key: Utils.getRandomNumber(),
    }
    Data.addCbRestate(Constants.module.RESTAURANT, Constants.donnee.reservation, this.restate)
  }

  restate = data => {
    this.props.updateSearch(data.results && data.results.length > 0 && data.results[0])
  }

  searchResa = async (data, name) => {
    const search = EurestoClone(this.state.search)

    if (name === '%date_reservation') {
      if (data === '|' && !Array.isArray(search.date_reservation)) {
        search.date_reservation = [search.date_reservation, search.date_reservation]
      } else if (data !== '|' && Array.isArray(search.date_reservation)) {
        search.date_reservation = search.date_reservation[0]
      }
    }

    console.log(name, data)

    if (name === '?checkbox') {
      search.niveau = data ? (this.props.type !== 'demande' ? [4] : [0, 4]) : (this.props.type !== 'demande' ? [4, 5] : [0])
    }

    if (name === 'produit_id') {
      search.service_id = null
    }
    search[name] = data


    this.setState({
      search: search,
    }, () => this.props.searching && this.props.searching(search))
  }

  render() {
    return (
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
        alignItems={'stretch'}
        alignContent={'flex-start'}
        direction={'column'}>
        <DatePicker value={this.state.search['date_reservation']}
          range={false}
          title={EurestoI18n.t('commun:Date Réservation')}
          onChange={this.searchResa}
          name={'date_reservation'} />
        <i
          className={'EurestoPrimary--text cursor-pointer'}
          style={{
            fontSize: 12,
            lineHeight: '11px',
            marginBottom: 5,
            marginTop: -2,
            textDecorationColor: EurestoColor('EurestoPrimary'),
            textDecoration: 'underline'
          }}
          onClick={_ =>
            this.setState({
              search: {
                ...(this.state.search || {}),
              }
            }, _ => this.searchResa(moment().format('YYYY-MM-DD'), 'date_reservation'))}>
          {EurestoI18n.t(`commun:Aujourd'hui`)}</i>
        <DataComponent
          title={EurestoI18n.t('crm:Restaurant')}
          name="produit_id"
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.searchResa}
          data={this.state.search.produit_id}
          object={Constants.donnee.produit}
          module={Constants.module.RESTAURANT}
        />
        <DataComponent
          key={this.state.search.produit_id}
          title={EurestoI18n.t('crm:Service')}
          name="service_id"
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.searchResa}

          data={this.state.search.service_id}
          object={Constants.donnee.service}
          module={Constants.module.RESTAURANT}
          search={{ produit_id: this.state.search.produit_id }}
        />
        <Checkbox
          name={"?checkbox"}
          checked={this.state.search["?checkbox"]}
          onChange={this.searchResa}
          label={EurestoI18n.t(`commun:Afficher les ${this.props.type !== 'demande' ? "annulées" : "refusées"}`)} />
        <InputClient contact_id={this.state.search.contact_id} onChange={this.searchResa} />
        {this.props.type !== 'demande' && <div>
          Code couleurs
          <div>
            <div style={{
              background: Utils.reservationColor(3),
              color: Color(Utils.reservationColor(3)).isDark() ? 'white' : 'black',
              width: 10,
              height: 10,
              display: 'inline-block',
              borderRadius: '50%'
            }} />
            &nbsp;
            Confirmée(s)
          </div>
          <div>
            <div style={{
              background: Utils.reservationColor(2),
              color: Color(Utils.reservationColor(2)).isDark() ? 'white' : 'black',
              width: 10,
              height: 10,
              display: 'inline-block',
              borderRadius: '50%'
            }} />
            &nbsp;
            En attente(s)
          </div>
          <div>
            <div style={{
              background: Utils.reservationColor(1),
              color: Color(Utils.reservationColor(1)).isDark() ? 'white' : 'black',
              width: 10,
              height: 10,
              display: 'inline-block',
              borderRadius: '50%'
            }} />
            &nbsp;
            Option(s)
          </div>
          <div>
            <div style={{
              background: Utils.reservationColor(5),
              color: Color(Utils.reservationColor(5)).isDark() ? 'white' : 'black',
              width: 10,
              height: 10,
              display: 'inline-block',
              borderRadius: '50%'
            }} />
            &nbsp;
            Annulée(s)
          </div>
        </div>}
      </Grid>
    )
  }

}

export default (SearchResa)



// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/Component/Search/Resa.js